module.exports = __webpack_public_path__ + "img/houtai.0c7284a0.png";